import { FaPlay } from "react-icons/fa";
import sectionsJson from "../data/selections/sectionDefinition.json";

const xlsxFilePath = selectedState => {
  const {
    areaId,
    pathId,
    fieldId,
    partId,
    sectionId,
    elementId
  } = selectedState
  return `/data/xlsx/${partId}/${sectionId}/${elementId}/${partId}_${sectionId}_${elementId}_${areaId}_${pathId}_${fieldId}.xlsx`
}

  const findElement = (selectedState, section) => {
    if (section.hasOwnProperty("elements")) {
      return section.elements.find(e => e.id === selectedState.elementId)
    } else {
      return null
    }
  }

  const downloadFileName = (selectedState) => {
    const section = sectionsJson[selectedState.partId].sections.find(e => e.id === selectedState.sectionId)
    const element = findElement(selectedState, section)
    if (element === null) {
      return section.name
    } else {
      return `${section.name}（${element.name}）`
    }
  }

function DownloadButton({ selectedState }) {
  return (
    <a className="ml-auto" href={xlsxFilePath(selectedState)} download={downloadFileName(selectedState)}>
      <button
        className="
          ml-auto mr-3 sm:mr-6 my-4
          w-48 h-11
          bg-btn-yellow rounded-md
          text-main-blue font-semibold
          border-0
        "
        >
        <span className="inline-block px-1 sm:px-3">
          <span className="hidden sm:inline">資料を</span>
          ダウンロード
        </span>
        <span className="inline-block px-1 sm:px-3 align-middle pb-1">
          <FaPlay size={10} />
        </span>
      </button>
    </a>

  );
}

export default DownloadButton;
